import { IconButton, SxProps, Theme, useTheme } from "@mui/material";
import { CircleXFill } from "akar-icons";
import React from "react";
import { ICustomerPortalTheme } from "../../entities/CustomerPortalTheme";

interface IIconButtonProps {
  onClick: () => any;
  size?: number;
  sx?: SxProps<Theme>;
}

export const CircleXIconButton = ({ onClick, size = 14, sx }: IIconButtonProps): JSX.Element => {
  const theme = useTheme<ICustomerPortalTheme>();
  return (
    <IconButton
      onClick={onClick}
      sx={{
        padding: "3px 3px",
        ...sx,
      }}
    >
      <CircleXFill strokeWidth={2} size={size} fill={theme.modernIconsColor} />
    </IconButton>
  );
};
